import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL, PagedResponse } from '@edl-development/edl-common';
import { AssignmentDTO } from '../model/assignments/assignment-management-dto.model';
import { BulkAssignmentResultDTO } from '../model/assignments/bulk-assign/bulk-assignment-result-dto.model';
import { BulkAssignmentTemplateType } from '../model/enum/assignments/bulk-assignment-template-type.enum';
import { AssignmentsRequestDTO } from '../model/assignments/assignments-request-dto.model';
import { DEFAULT_ASSIGNMENT_REQUEST_DTO } from '../assignments/common/constants/default-assignments-request-dto.const';

@Injectable()
export class AssignmentsApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }
    
    getAssignments(assignmentRequest: AssignmentsRequestDTO) {
        const body = { ...DEFAULT_ASSIGNMENT_REQUEST_DTO, ...assignmentRequest };
        return this.http.post<PagedResponse<AssignmentDTO>>(this.baseUri + '/assignments/Get', body);
    }

    addBuildingAssignments(buildingAssignments: {buildingId: number | null, userIds:string[]}) {
        return this.http.post(this.baseUri + '/assignments/addBuildingAssignments',  buildingAssignments );
    }

    removeBuildingAssignments(buildingAssignments: {buildingId: number | null, userIds:string[]}) {
        return this.http.put(this.baseUri + '/assignments/removeBuildingAssignments', buildingAssignments );
    }

    addBuildingLeads(buildingAssignments: {buildingId: number | null, userIds:string[]}) {
        return this.http.post(this.baseUri + '/assignments/addBuildingLeads',  buildingAssignments );
    }

    removeBuildingLeads(buildingAssignments: {buildingId: number | null, userIds:string[]}) {
        return this.http.put(this.baseUri + '/assignments/removeBuildingLeads', buildingAssignments );
    }

    downloadBulkUpdateTemplate(templateType: BulkAssignmentTemplateType) {
        const params = new HttpParams()
            .append('templateType', String(templateType))

        return this.http.get(`${this.baseUri}/assignments/DownloadBulkUpdateTemplate`, { params, responseType: 'blob' });
    }

    bulkUpdatePreview = (file: File) => {
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<BulkAssignmentResultDTO>(`${this.baseUri}/assignments/BulkUpdatePreview`, formData);
    }

    bulkUpdate = (file: File) => {
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<BulkAssignmentResultDTO>(`${this.baseUri}/assignments/BulkUpdate`, formData);
    }
}
